@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Pennsylvania</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      @if (baseRules["Medical_Limit_Text"]?.includes("show")) {
      <div class="axis-form-group">
        <label class="axis-control-label">
          {{ textValues?.Medical_Limit_Text }}
        </label>
      </div>
      }
      <div class="axis-grid">
        @if (baseRules["MedicalExpenseBenefits_DropDown"]?.includes("show")) {
          
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required': 
                  reactiveForm.get(controls[1].formControlName)?.value === null ||
                  reactiveForm.get(controls[1].formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(controls[1].formControlName)?.touched &&
                    reactiveForm.get(controls[1].formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ controls[1].formControlName }}"
                  >{{ controls[1].label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="controls[1].data"
                  id="{{ controls[1].formControlName }}"
                  formControlName="{{ controls[1].formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                  @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          
          }
        @if (baseRules["WorkLossBenefits_DropDown"]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
                  'has-axis-error':
                    reactiveForm.get(controls[2].formControlName)?.touched &&
                    reactiveForm.get(controls[2].formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ controls[2].formControlName }}"
                  >{{ controls[2].label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="controls[2].data"
                  id="{{ controls[2].formControlName }}"
                  formControlName="{{ controls[2].formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(controls[2].formControlName)?.touched) {
                  @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the option.</span
                    >
                  }
                }
              </div>
            </div>
          }
          @if (baseRules["FuneralExpenseBenefits_DropDown"]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required': reactiveForm.get(controls[3].formControlName)?.value === null,
                  'has-axis-error':
                    reactiveForm.get(controls[3].formControlName)?.touched &&
                    reactiveForm.get(controls[3].formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ controls[3].formControlName }}"
                  >{{ controls[3].label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="controls[3].data"
                  id="{{ controls[3].formControlName }}"
                  formControlName="{{ controls[3].formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(controls[3].formControlName)?.touched) {
                  @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the option.</span
                    >
                  }
                }
              </div>
            </div>
          
          }
          @if (baseRules["AccidentalDeathBenefits_DropDown"]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required': reactiveForm.get(controls[4].formControlName)?.value === null,
                  'has-axis-error':
                    reactiveForm.get(controls[4].formControlName)?.touched &&
                    reactiveForm.get(controls[4].formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ controls[4].formControlName }}"
                  >{{ controls[4].label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="controls[4].data"
                  id="{{ controls[4].formControlName }}"
                  formControlName="{{ controls[4].formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(controls[4].formControlName)?.touched) {
                  @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the option.</span
                    >
                  }
                }
              </div>
            </div>
        }

        @if (baseRules["OPTIONS_DropDown"]?.includes("show") || baseRules["OPTIONS_DropDown"]?.includes("form")) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required': reactiveForm.get(controls[5].formControlName)?.value === null,
                'has-axis-error':
                  reactiveForm.get(controls[5].formControlName)?.touched &&
                  reactiveForm.get(controls[5].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[5].formControlName }}"
                >{{ controls[5].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[5].data"
                (onSelect)="onSelect($event, baseRules['selectionId'], controls[5].formControlName)"
                id="{{ controls[5].formControlName }}"
                formControlName="{{ controls[5].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[5].formControlName)?.touched) {
                @if (reactiveForm.get(controls[5].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select the option.</span
                  >
                }
              }
              @if (optionsSelection.accidentalDeathBenefits) {
                <div>Accidental Death Benefits: {{ optionsSelection.accidentalDeathBenefits }}</div>
              }
              @if (optionsSelection.totalLimit) {
                <div>Maximum Total Limit for All Combination First-Party Benefits:
                  {{ optionsSelection.totalLimit }}</div>
              }
            </div>
          </div>
        }
      </div>
      <div class="axis-grid">
        @if (
          baseRules["ExtraordinaryMedicalBenefits_DropDown"]?.includes("show") ||
          baseRules["ExtraordinaryMedicalBenefits_DropDown"]?.includes("form")
        ) {
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group"
              [ngClass]="{
                'has-axis-required': reactiveForm.get(controls[6].formControlName)?.value === null,
                'has-axis-error':
                  reactiveForm.get(controls[6].formControlName)?.touched &&
                  reactiveForm.get(controls[6].formControlName)?.invalid,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[6].formControlName }}"
                >{{ controls[6].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                (onSelect)="onSelect($event, baseRules['selectionId'], controls[6].formControlName)"
                [dataProvider]="controls[6].data"
                id="{{ controls[6].formControlName }}"
                formControlName="{{ controls[6].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[6].formControlName)?.touched) {
                @if (reactiveForm.get(controls[6].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select the option.</span
                  >
                }
              }
            </div>
          </div>
        }
      </div> 
      <div class="axis-grid">
        @if (baseRules["ExtraordinaryMaxMedicalBenefits_ReadOnly"]?.includes("show")) {
        <div class="axis-col-sm-6 axis-col-md-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[6].label }}</label>
            <div id="extraordinarymedicalbenefits_1M-pdffield-pennsylvania">{{ controls[6].data[3].name }}</div>
          </div>
        </div>
        }
        @if (baseRules["ExtraordinaryMaxMedicalBenefits_MinLimit_ReadOnly"]?.includes("show")) {
        <div class="axis-col-sm-6 axis-col-md-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[6].label }}</label>
            <div id="extraordinarymedicalbenefits_100k-pdffield-pennsylvania">{{ controls[6].data[0].name }}</div>
          </div>
        </div>
        }
      </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Pennsylvania</h2>
  @if (baseRules?.noSelection === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label"
        >PIP Coverage will be provided at the minimum limits required by state law.</label
      >
    </div>
  }
}
